import { render, staticRenderFns } from "./mailbox.vue?vue&type=template&id=3219f3b2&scoped=true"
import script from "./mailbox.vue?vue&type=script&lang=js"
export * from "./mailbox.vue?vue&type=script&lang=js"
import style0 from "./mailbox.vue?vue&type=style&index=0&id=3219f3b2&prod&lang=scss"
import style1 from "./mailbox.vue?vue&type=style&index=1&id=3219f3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3219f3b2",
  null
  
)

export default component.exports